module.exports = __webpack_public_path__ + "img/hest13.296d9c74.jpg";